export default {_name:'card.simple.small',module:'Field',view:'Element/Card/Small',options:{sm:3,xs:12},mobileOptions:{ms:3}}